import { Chip, Stack, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useSnackbar } from 'notistack';
import ExpandableText from '../common/ExpandableText';
import LinkifiedText from '../common/LinkifiedText';
import { downloadHomeworkFile } from '../../api/lessons';

// Скачування через axios-blob: auth — Bearer-заголовок, тож звичайне <a href> дало б 401
const saveBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'file';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const HomeworkCell = ({ lesson }) => {
  const { enqueueSnackbar } = useSnackbar();
  const files = lesson.homeworkFiles || [];

  const handleDownload = async (file) => {
    try {
      const blob = await downloadHomeworkFile(lesson.id, file.id);
      saveBlob(blob, file.fileName);
    } catch {
      // тіло помилки — Blob, не парсимо
      enqueueSnackbar('Не вдалося завантажити файл', { variant: 'error' });
    }
  };

  if (!lesson.homeworkTask && !files.length) {
    return (
      <Typography variant="body2" sx={{ color: '#C4B5FD', fontStyle: 'italic' }}>
        Не задано
      </Typography>
    );
  }

  return (
    <Stack spacing={0.75}>
      {lesson.homeworkTask && (
        <ExpandableText
          lines={3}
          sx={{ bgcolor: '#F8F7FF', border: '1px solid #EDE9FE', borderRadius: 2, px: 1.5, py: 0.75 }}
        >
          <LinkifiedText text={lesson.homeworkTask} />
        </ExpandableText>
      )}
      {files.length > 0 && (
        <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
          {files.map((file) => (
            <Chip
              key={file.id}
              size="small"
              icon={<AttachFileIcon sx={{ fontSize: 14 }} />}
              label={file.fileName}
              onClick={() => handleDownload(file)}
              sx={{
                maxWidth: 180,
                fontSize: 11,
                bgcolor: '#F8F7FF',
                border: '1px solid #EDE9FE',
                cursor: 'pointer',
                '&:hover': { bgcolor: '#EDE9FE' },
              }}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default HomeworkCell;
